import { useEffect } from "react";

import { InitialOrderDataPart } from "../../constants";
import useOrderData from "../../context/useOrderData";

const useSetIsInitialDataLoaded = (): void => {
  const {
    loadedInitialData,
    setInitialDataPartLoaded,
    dynamicData: { pickupTimeFrames },
  } = useOrderData();

  const isPrefillDataLoaded = loadedInitialData[InitialOrderDataPart.PREFILL_VALUES];

  useEffect(() => {
    if (!isPrefillDataLoaded || !pickupTimeFrames) {
      return;
    }
    setInitialDataPartLoaded(InitialOrderDataPart.PICKUP_TIMEFRAMES);
  }, [isPrefillDataLoaded, pickupTimeFrames, setInitialDataPartLoaded]);
};
export default useSetIsInitialDataLoaded;
